export const flightCategoryDictionary = {
    '': 'Choose flight category',
    1: 'Planned',
    2: 'Preventive',
    3: 'Emergency',
}

export const flightStatusDictionary = {
    1: 'Proposed',
    2: 'Verified',
    3: 'In progress',
    4: 'Completed',
}

export const droneTypeDictionary = {
    1: 'Other',
    2: 'Multirotor',
    3: 'Fixedwing',
}

//required is set to true for project attribute, which can't be changed
export const fieldsDictionary = {
    id: {
        header: 'ID',
        name: 'id',
        isEditable: false,
        width: 50,
        renderType: 'text',
        isClientSide: false,
        required: true,
    },
    //this field is required
    projectName: {
        header: 'Project name',
        name: 'projectName',
        isEditable: true,
        width: 180,
        renderType: 'text',
        //placeholder: 'eg. AAA.BBB.02.2018',
        isClientSide: true,
        required: true,
    },
    projectNumber: {
        header: 'Project number',
        name: 'projectNumber',
        isEditable: true,
        width: 180,
        renderType: 'text',
        isClientSide: true,
        required: false,
    },
    projectManager: {
        header: 'Project manager',
        name: 'projectManager',
        isEditable: true,
        width: 180,
        renderType: 'text',
        isClientSide: true,
        required: false,
    },
    flightCategory: {
        header: 'Mission category',
        name: 'flightCategory',
        isEditable: true,
        width: 100,
        renderType: 'select',
        dictionary: flightCategoryDictionary,
        isClientSide: true,
        required: false,
    },
    flightStatus: {
        header: 'Status',
        name: 'flightStatus',
        tip: 'Set mission status',
        isEditable: true,
        width: 100,
        renderType: 'select',
        dictionary: flightStatusDictionary,
        isClientSide: true,
        required: false,
    },
    droneType: {
        header: 'Drone',
        name: 'dronrType',
        isEditable: true,
        width: 200,
        renderType: 'select',
        dictionary: droneTypeDictionary,
        isClientSide: false,
        required: false,
    },
    dateSurveyed: {
        header: 'Date surveyed',
        name: 'dateSurveyed',
        isEditable: true,
        width: 180,
        renderType: 'datetime',
        isClientSide: true,
        required: false,
    },
    voltageLevel: {
        header: 'Voltage',
        name: 'voltageLevel',
        tip: 'Voltage of the power line you are interested in',
        isEditable: true,
        width: 100,
        renderType: 'text',
        placeholder: '360V',
        isClientSide: true,
        required: false,
    },
    startPoint: {
        header: 'Start point',
        name: 'startPoint',
        isEditable: true,
        width: 180,
        renderType: 'text',
        //placeholder: 'eg. Royston',
        isClientSide: true,
        required: false,
    },
    location: {
        header: 'Location',
        name: 'location',
        //tip: 'Describe mission location',
        isEditable: true,
        width: 180,
        renderType: 'text',
        //placeholder: 'eg. Royston - Cambridge',
        isClientSide: true,
        required: false,
    },        
    plannedDateTime: {
        header: 'Planned start time',
        name: 'plannedDateTime',
        isEditable: true,
        width: 180,
        renderType: 'datetime',
        isClientSide: true,
        required: false,
    },
    plannedDuration: {
        header: 'Flight duration',
        name: 'plannedDuration',
        isEditable: true,
        width: 100,
        renderType: 'numeric',
        unit: 'min.',
        placeholder: 'eg. 120',
        isClientSide: false,
        required: false,
    },
    plannedLenght: {
        header: 'Flight length',
        name: 'plannedLenght',
        isEditable: true,
        width: 100,
        renderType: 'numeric',
        unit: 'km',
        placeholder: 'eg. 50',
        isClientSide: false,
        required: false,
    },
    beginDateTime: {
        header: 'Start time',
        name: 'beginDateTime',
        isEditable: false,
        width: 180,
        renderType: 'datetime',
        isClientSide: false,
        required: false,
    },
    endDateTime: {
        header: 'End time',
        name: 'endDateTime',
        isEditable: false,
        width: 180,
        renderType: 'datetime',
        isClientSide: false,
        required: false,
    },
    createdByUserName: {
        header: 'Created by',
        name: 'createdByUserName',
        isEditable: false,
        width: 100,
        renderType: 'text',
        isClientSide: false,
        required: true,
    },
    createdDateTime: {
        header: 'Created on',
        name: 'createdDateTime',
        isEditable: false,
        width: 180,
        renderType: 'datetime',
        isClientSide: false,
        required: true,
    },
    modifiedByUserName: {
        header: 'Modified by',
        name: 'modifiedByUserName',
        isEditable: false,
        width: 100,
        renderType: 'text',
        isClientSide: false,
        required: true,
    },
    modifiedDateTime: {
        header: 'Modified on',
        name: 'modifiedDateTime',
        isEditable: false,
        width: 180,
        renderType: 'datetime',
        isClientSide: false,
        required: true,
    },
    model3DUrl: {
        header: 'Model 3D',
        name: 'model3DUrl',
        tip: 'A link for 3D object model',
        isEditable: true,
        width: 200,
        renderType: 'link',
        isClientSide: false,
        required: false,
    },
    reportUrl: {
        header: 'Report',
        name: 'reportUrl',
        tip: 'A link for mission report',
        isEditable: true,
        width: 200,
        renderType: 'link',
        isClientSide: false,
        required: false,
    },
    projectProducts: {
        header: 'Order products',
        name: 'projectProducts',
        isEditable: true,
        width: 200,
        renderType: 'multicheckbox',
        isClientSide: true,
        required: false,
    },
    comments: {
        header: 'Comments',
        name: 'comments',
        isEditable: true,
        width: 200,
        renderType: 'text',
        isClientSide: false,
        required: false,
    }
}


// WEBPACK FOOTER //
// ./src/utilities/flightDictionaries.js